import { AfterViewInit, Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import Article from 'src/smoothr-web-app-core/models/Article';
import { numberD } from 'src/smoothr-web-app-core/utils/utils';
export interface NutritionValue {
	$numberDecimal: string;
}
export interface Nutrition {
	portionInG: NutritionValue;
	energyKcalPerPortion: NutritionValue;
	energyKcalPer100g: NutritionValue;
	energyKjPerPortion: NutritionValue;
	energyKjPer100g: NutritionValue;
	fatPerPortion: NutritionValue;
	fatPer100g: NutritionValue;
	saturatesPerPortion: NutritionValue;
	saturatesPer100g: NutritionValue;
	carbohydratePerPortion: NutritionValue;
	carbohydratePer100g: NutritionValue;
	sugarPerPortion: NutritionValue;
	sugarPer100g: NutritionValue;
	proteinPerPortion: NutritionValue;
	proteinPer100g: NutritionValue;
	saltPerPortion: NutritionValue;
	saltPer100g: NutritionValue;
	unit: string;
}

@Component({
	selector: 'app-short-info-modal',
	templateUrl: './short-info-modal.component.html',
	styleUrls: ['short-info-modal.component.scss'],
	standalone: false,
})
export class ShortInfoModalComponent implements AfterViewInit {
	article!: Article;
	compound: any;
	environment = environment;
	numberD = numberD;

	constructor(private modalCtrl: ModalController) {}
	ngAfterViewInit(): void {
		console.log('ShortInfoModalComponent  article ---', this.article.compound.allergens);
	}
	static async show(modalCtrl: ModalController, article: Article) {
		const modal = await modalCtrl.create({
			cssClass: 'allergens-modal',
			component: ShortInfoModalComponent,
			componentProps: {
				article,
				compound: article?.compound,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}

	isAllergens(article: Article) {
		if (article?.compound?.allergens) return Object.values(article?.compound?.allergens)?.find(it => it === true);
		else return null;
	}

	isAddit(article: Article) {
		if (article?.compound?.additives) return Object.values(article?.compound?.additives)?.find(it => it === true);
		else return null;
	}
	isHaveAnyValueMoreZero(article: Article) {
		if (!article?.nutritions) {
			return false;
		}
		return Object.values(article.nutritions)
			.map(it => (numberD(it) ? numberD(it) : 0))
			.find(it => it > 0);
	}
	convertNumber(value: NutritionValue) {
		if (!value) {
			return '';
		}
		return numberD(value).toString().replace('.', ',');
	}

	isTraces(article: Article) {
		if (!article?.compound?.traces) {
			return null;
		}
		return Object.values(article?.compound?.traces).find(it => it === true);
	}
}
